import { Avatar, Box, Divider, Grid, Stack } from "@mui/material";
import CollapsibleCard from "components/UI/molecules/CollapsibleCard";
import React from "react";
import VerifiedIcon from "@mui/icons-material/Verified";
import JobManageOptions from "./JobManageOptions";
import {
  formatAddress,
  getDefaultIconByType,
  linkByComponent,
} from "helpers/utils/utilities";
import { COMPONENT_TYPES } from "helpers/utils/constants";
import { Link } from "react-router-dom";
import moment from "moment";
import { isTrue } from "helpers/utils/validators";
import Button from "components/Button";
import { capitalize } from "lodash";
import ChipsPreview from "components/UI/atoms/ChipsPreview";

const APPLICATION_STATUS_COLOR = {
  shortlisted: "purple",
  pending: "orange",
  interview: "blue",
  offer: "darkBlue",
  hired: "green",
  rejected: "red",
};

const JobCard = ({
  data,
  defaultExpanded,
  col,
  deleteJob,
  manage,
  t = (d) => d,
  onApply,
  myJob,
  disableManage,
}) => {
  return (
    <CollapsibleCard
      defaultExpanded={defaultExpanded}
      noExapandCollapse={col}
      showContent={
        <Grid container columnSpacing={2} alignItems="center">
          <Grid
            item
            xs={col ? 12 : 10}
            display="flex"
            alignItems={!col && "center"}
          >
            <Avatar
              src={data?.profile_image}
              className={`${col ? "h-50 w-50" : "h-60 w-60"} bg-white border`}
            >
              <img
                src={getDefaultIconByType(COMPONENT_TYPES.ORGANIZATION)}
                className={`${col ? "h-50 w-50" : "h-60 w-60"}`}
                alt="organization icon"
              />
            </Avatar>
            <Box className="ml-2 overflow-hidden">
              <Link
                to={linkByComponent(
                  COMPONENT_TYPES.JOB_NETWORK,
                  data?.uuid,
                  manage && !disableManage
                )}
                className="c-primary text-truncate text-decoration-none"
              >
                <h2
                  className={`fs-22 fs-18--mob text-truncate ${
                    col && "maxw-230"
                  }`}
                >
                  {data?.title}
                </h2>
              </Link>
              <Stack
                direction={col ? "column" : "row"}
                whiteSpace="nowrap"
                flexWrap={col ? "wrap" : "nowrap"}
                alignItems="flex-start"
                justifyContent="start"
                className={`tracking-tight ${col ? "minh-75" : ""} fs-14`}
                gap={1}
              >
                <p className={`c-primary fw-500 gap-1 flex-center`}>
                  {data?.organization}
                  {isTrue(data?.is_verified) && (
                    <VerifiedIcon className="ml-1" fontSize="small" />
                  )}
                </p>
                {!col && (
                  <Divider
                    className="h-20"
                    variant="fullWidth"
                    orientation="vertical"
                  />
                )}

                {data?.status !== "draft" ? (
                  <>
                    <p className="c-title">
                      {t("Posted")}: {moment(data?.date_posted).fromNow()}
                    </p>
                    {!col && (
                      <Divider
                        className="h-20"
                        variant="fullWidth"
                        orientation="vertical"
                      />
                    )}
                  </>
                ) : null}

                <p className="c-title">
                  {t("Deadline")}:{" "}
                  {moment(data?.application_deadline).format("DD/MM/YYYY")}
                </p>
              </Stack>
              <ChipsPreview
                items={[
                  data?.job_type,
                  data?.experience_level,
                  data?.work_mode,
                  formatAddress(data?.address),
                ].filter(Boolean)}
                noMaxWidth
                classes={col && "minh-60"}
              />
            </Box>
          </Grid>
          <Grid item xs={col ? 12 : 2} justifyContent="flex-end" display="flex">
            {!manage ? (
              myJob || isTrue(data?.application_applied) ? (
                <Button
                  height="33px"
                  classes={`${col ? "mt-2" : "mr-2"} minw-100`}
                  color={APPLICATION_STATUS_COLOR[data?.application_status]}
                >
                  {t(capitalize(data?.application_status), "common") ||
                    t("Pending", "common")}
                </Button>
              ) : (
                <Button
                  onClick={onApply}
                  height="33px"
                  width="100px"
                  classes={col ? "mt-2" : "mr-2"}
                >
                  {t("Apply")}
                </Button>
              )
            ) : (
              <JobManageOptions
                data={data}
                onDelete={deleteJob}
                classes={col ? "mt-2" : "mr-2"}
                disabled={disableManage}
              />
            )}
          </Grid>
        </Grid>
      }
    >
      <Box className="mb-6 mt-2">
        <p
          dangerouslySetInnerHTML={{
            __html: data?.description,
          }}
        ></p>
      </Box>
    </CollapsibleCard>
  );
};

export default JobCard;
